
import http from '@/support/plugin/axios'

export const 

getEventsByCurrentContactIdAndCompanyId = ( companyId, list ) => {
    var query = ''
    
    if(list != null && list.length > 0){
        
        var listStr = '';
    
        list.forEach( element => {
            if( listStr != '' ) {
                listStr = `${listStr},`
            }
                listStr += element;
            }
        )

        query+="?types=" + listStr;

        return http.get(`companies/${companyId}/contacts/current/events${query}`)
    
    } else {
        return http.get(`companies/${companyId}/contacts/current/events`)
    }
},

getSavedMoneyByCompanyIdAndCurrentContactId = (companyId) => http.get(`companies/${companyId}/contacts/current/offers/saved-money`)